// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flight-list .card {
    height: 100dvh;
}

.flight-list .card-header {
    flex-shrink: 0;
}

.flight-list .card-body {
    overflow: hidden;
    padding-bottom: 88px;
}

.flight-list .card-body-content {
    min-height: 0;
}

.flight-list .item-list-card {
    flex: 1;
    min-height: 0;
    height: auto;
    margin-bottom: 0;
}

.flight-list .item-list-grid-wrapper {
    flex: 1;
    min-height: 0;
    height: auto;
}

.flight-list .item-list-actions {
    margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/web/component/FlightList/styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".flight-list .card {\n    height: 100dvh;\n}\n\n.flight-list .card-header {\n    flex-shrink: 0;\n}\n\n.flight-list .card-body {\n    overflow: hidden;\n    padding-bottom: 88px;\n}\n\n.flight-list .card-body-content {\n    min-height: 0;\n}\n\n.flight-list .item-list-card {\n    flex: 1;\n    min-height: 0;\n    height: auto;\n    margin-bottom: 0;\n}\n\n.flight-list .item-list-grid-wrapper {\n    flex: 1;\n    min-height: 0;\n    height: auto;\n}\n\n.flight-list .item-list-actions {\n    margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
